import { getApi, postApi } from "../api";
import { encryptdata } from "../../../utils/encryptDecrypt";

export const getAllLeadApi = (data) => getApi(`lead/distributedleads/category/${encryptdata(5)}`);
// export const getAllLeadApi = (data) => getApi(`/lead/all`);
export const getThisWeekBusinessLeadApi = () => getApi(`/lead/this-week`);
export const getAllTxnApi = (data) => getApi(`/txn/all`);
export const getWalletAmountApi = (data) => getApi(`/txn/wallet`);
export const submitDuplicateApi = (data) => postApi(`/ticket/create`, data);
export const getDuplicateApi = (data) => getApi(`/ticket/list`);